import { create } from "../api/answer";
import { getFeed } from "./user";

export const AnswerTypes = {
  CREATE_START: "answer/CREATE_START",
  CREATE_FAILURE: "answer/CREATE_FAILURE",
  CREATE_SUCCESS: "answer/CREATE_SUCCESS",
  SET_ANSWER: "answer/SET_ANSWER"
};

export const setAnswer = payload => ({
  type: AnswerTypes.SET_ANSWER,
  payload
});

export const createStart = payload => ({
  type: AnswerTypes.CREATE_START,
  payload
});

export const createSuccess = payload => ({
  type: AnswerTypes.CREATE_SUCCESS,
  payload
});

export const createFailure = payload => ({
  type: AnswerTypes.CREATE_FAILURE,
  payload
});

export const createAnswer = payload => async dispatch => {
  dispatch(createStart());

  const response = await create(payload);
  const body = await response.json();

  if (response.ok) {
    // const { answer } = body.payload;

    dispatch(createSuccess());
    dispatch(getFeed());
  } else {
    dispatch(createFailure(body.payload));
  }
};



// WEBPACK FOOTER //
// ./src/actions/answer.js